import { Controller } from "stimulus";
import { confirmationDialog } from "../helpers/dialog";

export default class extends Controller {
  _confirmationDialog(openDialog, confirmedButton, confirmedCallBack) {
    confirmationDialog(openDialog, confirmedButton, confirmedCallBack);
  }
}